module.exports = __webpack_public_path__ + "static/sign-up-gym-07d14b12b326686d041eca35294cb135.png";